// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1joBi3XKBiI9d5Hqrg0Oxk","default":"hM85e60lxbBpl8_mnlbuH","hover":"tLftiRZqAumiYwjlzpf9R","text":"_3q49WOsYVwAKD6zGlaBDPA"};